export default __webpack_public_path__ + "static/media/activeCalculator.2aa475cd.svg";